import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCoursesByUserUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllCoursesUser
  implements GetAllCoursesByUserUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllCoursesByUserUseCaseInterface.Result>,
  ) {}

  async execute(
    params?: GetAllCoursesByUserUseCaseInterface.Params,
  ): Promise<GetAllCoursesByUserUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}`, params),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
